import React, { useRef, useState } from "react";
import Input from "../../UI/Input";

import styles from "./MealItemForm.module.css";

function MealItemForm(props) {
  const [isValid, setIsValid] = useState(true);
  const amountInputRef = useRef();

  const submit = (event) => {
    event.preventDefault();
    const enteredAmount = +amountInputRef.current.value;
    if (enteredAmount.length === 0 || enteredAmount < 1 || enteredAmount > 5) {
      setIsValid(false);
      return;
    }
    props.onAddToCart(enteredAmount);
  };

  return (
    <form className={styles.form} onSubmit={submit}>
      <Input
        ref={amountInputRef}
        label="Amount"
        input={{
          type: "number",
          id: props.id,
          min: "1",
          max: "5",
          step: "1",
          defaultValue: "1",
        }}
      />
      <button>+ Add</button>
      {!isValid && <p>Please enter a valid amount (1-5)</p>}
    </form>
  );
}

export default MealItemForm;
